import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, ShoppingBag, FileText, ClipboardList, BarChart3, Inbox, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { LoginForm } from "@/components/admin/LoginForm";
import { ProductsTab } from "@/components/admin/ProductsTab";
import { BlogTab } from "@/components/admin/BlogTab";
import { ContentPlanTab } from "@/components/admin/ContentPlanTab";
import { AnalyticsTab } from "@/components/admin/AnalyticsTab";
import { LeadsTab } from "@/components/admin/LeadsTab";
import { ReviewsTab } from "@/components/admin/ReviewsTab";

const TABS = [
  { id: "leads", label: "Заявки", icon: Inbox },
  { id: "reviews", label: "Отзывы", icon: Star },
  { id: "products", label: "Букеты", icon: ShoppingBag },
  { id: "blog", label: "Блог", icon: FileText },
  { id: "content-plan", label: "Контент-план", icon: ClipboardList },
  { id: "analytics", label: "Аналитика", icon: BarChart3 },
];

export default function AdminPage() {
  const [password, setPassword] = useState(null);
  const [activeAdminTab, setActiveAdminTab] = useState("leads");
  const navigate = useNavigate();

  if (!password) return <LoginForm onLogin={setPassword} />;

  return (
    <div className="min-h-screen bg-gray-50" data-testid="admin-dashboard">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            <Logo variant="dark" />
            <span className="text-sm font-bold text-pink-500 bg-pink-50 px-3 py-1 rounded-full">ADMIN</span>
          </div>
          <div className="flex items-center gap-3">
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="rounded-full text-sm"
            >
              На сайт
            </Button>
            <Button
              onClick={() => navigate("/blog")}
              variant="outline"
              className="rounded-full text-sm"
              data-testid="admin-goto-blog"
            >
              Блог
            </Button>
            <button
              onClick={() => setPassword(null)}
              className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full"
              data-testid="admin-logout-btn"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
        {/* Admin Tabs */}
        <div className="flex gap-1 border-t border-gray-100 px-4 sm:px-6">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveAdminTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-bold border-b-2 transition-colors ${
                activeAdminTab === tab.id ? "border-pink-500 text-pink-600" : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
              data-testid={`admin-tab-${tab.id}`}
            >
              <tab.icon className="w-4 h-4" />
              {tab.label}
            </button>
          ))}
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        {activeAdminTab === "leads" && <LeadsTab password={password} />}
        {activeAdminTab === "reviews" && <ReviewsTab password={password} />}
        {activeAdminTab === "analytics" && <AnalyticsTab password={password} />}
        {activeAdminTab === "content-plan" && (
          <ContentPlanTab
            password={password}
            onCreateArticle={(article, city) => {
              setActiveAdminTab("blog");
              setTimeout(() => {
                window.__prefillBlogArticle = { ...article, city };
                window.dispatchEvent(new Event("prefillBlogArticle"));
              }, 100);
            }}
          />
        )}
        {activeAdminTab === "blog" && <BlogTab password={password} />}
        {activeAdminTab === "products" && <ProductsTab password={password} />}
      </div>
    </div>
  );
}
